export const signupFormFields = {
  companyName: '',
  country: 'US',
  firstName: '',
  lastName: '',
  email: '',
  street1: '',
  street2: '',
  city: '',
  postalCode: '',
  state: '',
  phone: '',
  emeaCompanyType: null,
  vatNumber: '',
};

export const requiredFormFields = [
  'city',
  'companyName',
  'email',
  'firstName',
  'lastName',
  'phone',
  'postalCode',
  'state',
  'street1',
];
